import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ThemeConstants } from 'src/app/@espire/shared/config/theme-constant';
import { RespuestaGenerica } from 'src/app/generales/RespuestaGenerica';
import { ServiciosRutas } from 'src/app/generales/ServiciosRutas';
import { AuthGuard } from 'src/app/guards/AuthGuard';
import { AuthIdentity } from 'src/app/guards/AuthIdentity';
import { ModuloModalMensajeComponent } from 'src/app/shared/modulo-modal-mensaje/modulo-modal-mensaje.component';
import { Lista_cotizaiones_response } from 'src/model/Catalogos/Cotizacion';
import { Lista_negocios_x_usuario_modelo_response, Lista_perfiles_modelo_response } from 'src/model/Catalogos/Generales';
import { Lista_usuarios_sistema_modelo_response, Usuario_sistema_modelo_response } from 'src/model/Catalogos/Usuarios';
import { ServiceGenerico } from 'src/services/service-generico.service';

@Component({
  selector: 'app-lista-cotizaciones',
  templateUrl: './lista-cotizaciones.component.html',
  styleUrls: ['./lista-cotizaciones.component.css'],
  providers: [ServiceGenerico]

})
export class ListaCotizacionesComponent implements OnInit {
  // @ViewChild("modalAddUsuario", { static: false }) modalAddUsuario: TemplateRef<any>;
  // @ViewChild("contentDesactivar", { static: false }) ModalDesactivar: TemplateRef<any>;
  // modalrefMsg: NgbModalRef;
  // modalAgregarUsuario: NgbModalRef;
  // modalEliminarUsuario: NgbModalRef;

  // formGroupAgregarUsuario: FormGroup;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;
  // public usuarioId: string = "";

  private modelo_configuracion: ServiciosRutas;
  // listaUsuarios: Lista_usuarios_sistema_modelo_response[];
  public operacionRespuesta: RespuestaGenerica;
  listaCotizaciones: Lista_cotizaiones_response[];
  opcion: number = 0;
  idUsuario: number;
  // esEditable: boolean = true;
  // funcionalidad: string;
  // _idUsuario: number;
  // private _nombreUsuario: any;
  // Usuario: Usuario_sistema_modelo_response;
  // listaPerfiles: Lista_perfiles_modelo_response[];
  // listaNegocios: Lista_negocios_x_usuario_modelo_response[];
  // selectedCheckboxes: string[] = []; // Array para almacenar los valores seleccionados

  constructor(
    private auth: AuthGuard,
    private themeConstants: ThemeConstants,
    private services: ServiceGenerico,
    private router: Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
  ) {
    this.modelo_configuracion = new ServiciosRutas();
    this.operacionRespuesta = new RespuestaGenerica();

    var usuarioActual = AuthIdentity.ObtenerUsuarioSesion();
    this.idUsuario = usuarioActual.IDUsuario;

  }

  ngOnInit() {
    this.inicializaTabla();
    this.obtenerCotizaciones();
    // this.inicializarFormAgregarUsuario();
    // this.getListaPerfiles();
    // this.getListaNegocios();

  }

  inicializaTabla() {
    this.dtOptions = this.themeConstants.dtOptions;
    this.dtTrigger = new Subject();
  }

  renderTabla() {
    if ("dtInstance" in this.dtElement) {
      this.dtElement.dtInstance.then((instancia: DataTables.Api) => {
        instancia.destroy();
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }
  
  obtenerCotizaciones() {
    this.operacionRespuesta.EstaEjecutando = true;
    this.services
      .HttpGet(
        this.modelo_configuracion.serviciosOperaciones + "/Cotizacion/GetListaCotizaciones?p_estatus=1&p_IDUsuario="+ this.idUsuario)
      .subscribe(
        (tempdate) => {
          if (tempdate) {
            this.listaCotizaciones = [] = tempdate.response as Lista_cotizaiones_response[];
            this.renderTabla();
          } else {
            this.listaCotizaciones = [];
            this.renderTabla();
          }
          this.operacionRespuesta.EstaEjecutando = false;
        },
        async (err) => {
          this.operacionRespuesta.EstaEjecutando = false;
        }
      );
  }

  verDetalleCotizacion(idCotizacion) {
    this.opcion = 1; 
  }
}
